import { useDispatch } from "react-redux";
import { useAlert } from "../../../context/AlertProvider";
import {
  connectCalendar,
  disconnectCalendar,
  getIntegrationSummary,
  syncLatestCalendarEvents,
} from "../../../actionCreator/calendarActionCreator";
import { useEffect } from "react";

export const useCalendarIntegration = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  useEffect(() => {
    dispatch(getIntegrationSummary());
  }, [dispatch]);

  const handleConnect = async (type) => {
    const res = await dispatch(connectCalendar(type));
    if (res?.status === 200) {
      window.open(res?.data?.authorizationUrl);
    } else {
      showAlert("error", `Something went wrong. Please try again.`);
    }
  };

  const handleDisconnect = async (type) => {
    const res = await dispatch(disconnectCalendar(type));

    if (res?.status === 200) {
      let message;

      switch (type) {
        case "Google":
          message = "Google calendar disconnected successfully.";
          break;
        case "Outlook":
          message = "Outlook calendar disconnected successfully.";
          break;
        default:
          message = `${type} disconnected successfully.`;
      }

      showAlert("success", message);
      dispatch(getIntegrationSummary());
    } else {
      showAlert("error", "Something went wrong. Please try again.");
    }
  };

  const handleLatestSync = async (type) => {
    const res = await dispatch(syncLatestCalendarEvents(type));

    if (res?.status === 200) {
      showAlert("success", "Events synced successfully.");
    } else {
      showAlert("error", "Something went wrong. Please try again.");
    }
  };

  return {
    handleConnect,
    handleDisconnect,
    handleLatestSync,
  };
};
